import React, {useRef} from "react";

import styles from "./Block.module.scss";
import Image from "../Global/Image";

const ComponentContent = (title, sectionTitle, number, children) => {
    return (
        <>
            <div className={styles.TitleWrapper}>
                {
                    sectionTitle ?
                        <small dangerouslySetInnerHTML={{__html: sectionTitle}}/>
                        : null
                }

                <h3 data-number={number} dangerouslySetInnerHTML={{__html: title}}/>
            </div>

        </>
    )
};

export default function Block({title, sectionTitle, number, container = false, background = 'white', mobile, color, classname, children}) {
    const style = window.getComputedStyle(document.querySelector('body'));
    const article = useRef(null);

    return (
        <article className={[styles.Main, classname ?? ''].join(' ')} style={{color: style.getPropertyValue(`--${color}`)}} ref={article}>
            { title || sectionTitle ? ComponentContent(title, sectionTitle, number, children) : null}
            {
                container ?
                    <div className="container">
                        { children }
                    </div>
                    : <>
                        <div className="container">

                        </div>
                        { children }


                    </>
            }

            <div className={styles.Background} style={{ backgroundColor: style.getPropertyValue(`--${background}`) }}>
                {
                    (typeof background === 'object') ?
                        <Image {...background} mobile={mobile}/> : null
                }
            </div>
        </article>
    )
}
